const chartTypes = Object.freeze({
  BAR_VERTICAL: 'bar_vertical',
  BAR_HORIZONTAL: 'bar_horizontal',
  LINE: 'line',
  PIE: 'pie',
});

export const { BAR_VERTICAL, BAR_HORIZONTAL, LINE, PIE } = chartTypes;
